/** Map Vite `--mode` to a key in `config.json` (local | prod; test for Playwright). */
export function resolveAppEnv(viteMode) {
  if (viteMode === "production") return "prod";
  if (viteMode === "test") return "test";
  return "local";
}
